module.exports = __webpack_public_path__ + "static/media/mountains.165bd9b5.svg";